/**
*
* MollieModal
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'react-bootstrap';
import RedirectButton from 'components/interaction/RedirectButton.jsx';
import mollieButton from './mollie.png';
import messages from './messages.js';

const Img = styled.img`
  height: 26px;
  width: auto;
  border-radius: 12px;
`;

function MollieModal(props) {
  const { accountId, show, onHide } = props;
  const referer = window.location.origin + window.location.pathname;
  const fetchOptions = { method: 'POST', url: `sa/bankaccounts/${accountId}/mollie`, version: 2, body: { referer } };
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title><FormattedMessage {...messages.connectViaMollie} /></Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <h3 className="my-4"><FormattedMessage {...messages.mollieStillConnected} /></h3>
        <p className="mx-3 mx-sm-5"><FormattedMessage {...messages.checkMollieConnection} /></p>
        <div className="my-5">
          <RedirectButton type="button" variant="link" className="p-0" fetchOptions={fetchOptions}>
            <Img src={mollieButton} alt="Connect via Mollie" />
          </RedirectButton>
        </div>
      </Modal.Body>
    </Modal>
  );
}

MollieModal.propTypes = {
  accountId: PropTypes.number,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default MollieModal;
